import React from 'react';
import clsx from 'clsx';

import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Container, { ContainerProps } from '@material-ui/core/Container';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      width: '100%',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  })
);

interface StepHeaderProps extends ContainerProps {
  title?: string;
  subtitle?: string;
  className?: string;
  children?: React.ReactNode;
}

const StepHeader = ({
  title,
  subtitle,
  className,
  children,
  ...containerProps
}: StepHeaderProps): React.ReactElement => {
  const classes = useStyles();

  return (
    <Container {...containerProps} className={clsx(classes.header, className)}>
      {title && <Typography variant="h4">{title}</Typography>}
      {subtitle && <Typography>{subtitle}</Typography>}
      {children}
    </Container>
  );
};

export default StepHeader;
